import type { HandlingUnitType } from '../handling-unit-type/handling-unit-type.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class HandlingUnitTypeFactory extends ObjectFactory<HandlingUnitType> {
  protected getDefaults(): HandlingUnitType {
    return {
      ...baseDocumentFactory.build(),
      code: 'SML-PARCEL',
      label: 'Small Parcel',
      volume: { unit: 'L', value: 5 },
      weight: { unit: 'kg', value: 2 },
    };
  }
}

export const handlingUnitTypeFactory = new HandlingUnitTypeFactory();
